import PaymentMethodsEmptyState from 'billing/components/PaymentMethodsEmptyState'
import {
  BillingMethodList,
  BillingMethodListItem,
} from 'billing/components/BillingMethodList'
import ConfirmDialog from 'components/ConfirmDialog'
import ContentError from 'components/ContentError'
import ContentLoading from 'components/ContentLoading'
import {
  DropdownItem,
  DropdownItemDescription,
  DropdownItemTitle,
} from 'components/Dropdown'
import ListHeader from 'components/ListHeader'
import { ContentEmpty } from 'components/ContentLayout'
import { observer } from 'mobx-react'
import * as React from 'react'
import { Id } from 'types/definitions'
import ProfilePaymentMethodsViewModel from './ProfilePaymentMethodsViewModel'
import Icon from 'components/Icon'

interface PaymentMethodsProps {
  vm: ProfilePaymentMethodsViewModel
}

export default observer(function PaymentMethods({ vm }: PaymentMethodsProps) {
  return (
    <>
      {vm.activate.match({
        pending: () => <ContentLoading />,
        rejected: (err) => <ContentError error={err} />,
        resolved: () => (
          <>
            {vm.paymentMethods.length === 0 ? (
              <ContentEmpty>
                <PaymentMethodsEmptyState
                  canAddPaymentMethod={true}
                  onNewPaymentMethod={vm.addPaymentMethod}
                />
              </ContentEmpty>
            ) : (
              <>
                <ListHeader count={vm.paymentMethods.length}>
                  Payment Methods
                </ListHeader>
                <BillingMethodList onAddClick={vm.addPaymentMethod}>
                  {vm.paymentMethods.map((method) => (
                    <BillingMethodListItem
                      selected={method.default}
                      disabled={
                        vm.setDefaulPaymentMethod.pending ||
                        vm.addPaymentMethod.pending
                      }
                      busy={
                        vm.setDefaulPaymentMethod.pending &&
                        vm.setDefaulPaymentMethod.args[0] === method
                      }
                      billingMethod={method}
                      key={Id.assert(method.id)}
                      dropdownActions={
                        <>
                          <DropdownItem
                            disabled={method.default}
                            onClick={() => vm.setDefaulPaymentMethod(method)}
                            icon={<Icon name="default-payment" />}
                          >
                            <DropdownItemTitle>
                              Set as Current
                            </DropdownItemTitle>
                            <DropdownItemDescription>
                              {method.default ? (
                                <>This payment method is already the default.</>
                              ) : (
                                <>
                                  Future payments will be charged to this
                                  payment method.
                                </>
                              )}
                            </DropdownItemDescription>
                          </DropdownItem>
                        </>
                      }
                    />
                  ))}
                </BillingMethodList>
              </>
            )}
          </>
        ),
      })}
      <ConfirmDialog
        title="Delete Payment Method"
        state={vm.deleteConfirmDialog}
        danger
        description="Are you sure you want to delete this payment method?"
        yesText="Delete Payment Method"
      />
    </>
  )
})
